module.exports = __webpack_public_path__ + "static/media/lenscareVNActive.443a163c.png";